export const getResultAPI="/career-aptitude-test-result";
export const getTestQuestionsAPI="/career-aptitude-test-questions";
export const sendCareerTestAnswersAPI="/career-aptitude-test";